import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import PokerDeAs from "@/components/sections/PokerDeAs";
import Servicios from "@/components/sections/Servicios";
import SobreTony from "@/components/sections/SobreTony";
import Clientes from "@/components/sections/Clientes";
import LeadForm from "@/components/sections/LeadForm";
import Footer from "@/components/sections/Footer";
import TurtopiaLanding from "@/pages/TurtopiaLanding";
import DescargarLeads from "@/pages/DescargarLeads";

function Landing() {
  return (
    <div className="App bg-black text-white" data-testid="landing-root">
      <Header />
      <main>
        <Hero />
        <PokerDeAs />
        <Servicios />
        <SobreTony />
        <Clientes />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,255,255,0.15)",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
        {/* Turtopía: hidden cinematic landing (no public navigation) */}
        <Route path="/turtopia" element={<TurtopiaLanding />} />
        {/* Hidden routes to auto-download leads as CSV */}
        <Route path="/descargar/:source" element={<DescargarLeads />} />
        <Route path="/descargar" element={<DescargarLeads />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
